import type { paths, definitions } from './__generated__/schema.ts';

type ValidPaths<T extends paths = paths> = keyof T;

export const Routes: Record<string, ValidPaths> = {
  ApplicationsApply: '/applications/apply/',
  ApplicationsIndustries: '/applications/industries/',
} as const;

export type Route = (typeof Routes)[keyof typeof Routes];

export type ApplicationIndustry = definitions['ApplicationIndustry'];
export type ApplicationPosition = definitions['ApplicationPositionSerializer'];

export type GetApplicationIndustriesResponse =
  paths['/applications/industries/']['get']['responses']['200']['schema'];

export type ApplicationApplyOutput = definitions['ApplicationApplyOutput'];
export type ApplicationApplyPayload =
  paths['/applications/apply/']['post']['parameters']['body']['data'];
export type ApplicationApplyResponse =
  paths['/applications/apply/']['post']['responses']['201']['schema'];
